export default ({
  progress,
  from = 0,
  to = 0,
  duration = 300,
  onCompleted,
}) => {
  const start = performance.now();

  const animation = (time) => {
    let timeFraction = (time - start) / duration;

    if (timeFraction > 1) {
      timeFraction = 1;
    }

    if (timeFraction >= 0) {
      // Тут можно изингов наклепать, например:
      // const easeOutQuad = timeFraction * (2 - timeFraction);
      // и вставить в progressFraction вместо timeFraction.

      // Линейный прогресс
      const progressFraction =
        from < to
          ? (to - from) * timeFraction + from
          : from - (from - to) * timeFraction;

      progress(progressFraction);
    }

    if (timeFraction < 1) {
      requestAnimationFrame(animation);
    } else {
      onCompleted && onCompleted();
    }
  };

  requestAnimationFrame(animation);
};
